import { render } from "./VabeneFeatureList.vue?vue&type=template&id=c32c0b12&ts=true"
import script from "./VabeneFeatureList.vue?vue&type=script&lang=ts"
export * from "./VabeneFeatureList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__